export default "__VITE_ASSET__f323agz5__"